import React from "react";
import Slider from "react-slick";
import "../assets/css/CarDetailsSlider.css";
import { LuImageOff } from "react-icons/lu";
const Url = process.env.REACT_APP_SERVER_URL;

const CarDetailsSlider = ({ carDetails }) => {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="mb-5 ">
      <Slider {...settings}>
        {carDetails?.imageGallery?.length > 0 ? (
          carDetails?.imageGallery?.map((img, index) => (
            <div key={index} className="slider-item "  >
              <img
                src={`${Url}/${img}`}
                alt={`"Car ${index + 1}`}
                className="w-100 h-100 object-cover"
              />
              <div className="overlay"></div>
            </div>
          ))
        ) : (
          <div className="flex items-center justify-center w-full h-[400px] bg-gray-200 rounded-lg">
            <LuImageOff className="w-20 h-20 text-gray-500" />
            <p className="text-gray-500 mt-2">No Image Available</p>
          </div>
        )}
      </Slider>
    </div>
  );
};

export default CarDetailsSlider;
